import { Checkbox, Col, Form, Modal, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface UpdateBidPackageReasonModalProps {
  visible1: boolean;
  onOk: (value: any) => void;
  onCancel: () => void;
}

function UpdateBidPackageReasonModal({
  visible1,
  onOk,
  onCancel,
}: UpdateBidPackageReasonModalProps) {
  const [form] = Form.useForm();

  return (
    <StyledDiv>
      <Modal
        visible={visible1}
        title="변경 이유 입력"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onOk(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form
            form={form}
            initialValues={{ isChanged: false }}
            layout="vertical"
          >
            <Row justify="center">
              <Col span={12}>
                <Form.Item
                  name="isChanged"
                  label="변경사항을 문자/이메일로 공유하시겠습니까?"
                  valuePropName="checked"
                >
                  <Checkbox style={{ width: '100%' }}>변경사항 공유</Checkbox>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.isChanged !== currentValues.isChanged
              }
            >
              {({ getFieldValue }) =>
                getFieldValue('isChanged') === true ? (
                  <Row justify="center">
                    <Col span={12}>
                      <Form.Item name="reason" label="변경 이유">
                        <TextArea
                          style={{ width: '100%' }}
                          rows={4}
                          placeholder="변경 이유를 입력하세요."
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : null
              }
            </Form.Item>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default UpdateBidPackageReasonModal;
